import { render, staticRenderFns } from "./UserNominations.vue?vue&type=template&id=6cb19353&scoped=true&"
import script from "./UserNominations.vue?vue&type=script&lang=js&"
export * from "./UserNominations.vue?vue&type=script&lang=js&"
import style0 from "./UserNominations.vue?vue&type=style&index=0&id=6cb19353&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb19353",
  null
  
)

export default component.exports